import QuestionAnswersPrefillYellow1 from './question-answers-yellow-1.json';
import QuestionAnswersPrefillYellow2 from './question-answers-yellow-2.json';
import QuestionAnswersPrefillYellow3 from './question-answers-yellow-3.json';

export default [
  QuestionAnswersPrefillYellow1,
  QuestionAnswersPrefillYellow2,
  QuestionAnswersPrefillYellow3,
];
